<div class="form-container">
    <div class="form-form">
        <div class="form-form-wrap">
            <div class="form-container">
                <div class="form-content">
                    <div class="text-center mb-2">
                        <img width="250" src="/assets/images/logo_2.png" alt="">
                    </div>
                    <h2 class="">
                        <a href="javascript:void(0)"><span class="brand-name">GPS eLock Service</span></a>
                    </h2>
                    <p class="signup-link mb-3">Aleady have an account? <a href="/login" style="cursor: pointer;">Login
                            Here</a></p>
                    <!-- needs-validation -->
                    <form class="text-left" [formGroup]="form" action="javascript:void(0);" novalidate id="regForm">
                        <div class="form row">

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="name">User Name</label>
                                    <input type="text" formControlName="name" class="form-control mb-4" id="name">
                                    <!-- <div class="invalid-feedback">
                                        Please Provide User Name
                                    </div> -->
                                    <small class="error-msg"
                                        *ngIf="form.get('name')?.dirty && form.get('name')?.errors">
                                        <small *ngIf="form.get('name')?.errors?.required">
                                            Required
                                        </small>
                                    </small>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="mobileNo">Mobile No.</label>
                                    <input type="text" maxlength="10" (keypress)="restrictNumeric($event)"
                                        class="form-control mb-4" formControlName="mobileNo" id="mobileNo">
                                    <!-- <div class="invalid-feedback">
                                        Please Provide Mobile No.
                                    </div> -->
                                    <small class="error-msg"
                                        *ngIf="form.get('mobileNo')?.dirty && form.get('mobileNo')?.errors">
                                        <small *ngIf="form.get('mobileNo')?.errors?.required">
                                            Required
                                        </small>
                                        <small *ngIf="form.get('mobileNo')?.errors?.pattern">
                                            Please Provide Valid Mobile
                                        </small>
                                    </small>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="email">Email</label>
                                    <input type="text" class="form-control mb-4" formControlName="email" id="email">
                                    <!-- <div class="invalid-feedback">
                                        Please Provide Valid Email ID
                                    </div> -->
                                    <small class="error-msg"
                                        *ngIf="form.get('email')?.dirty && form.get('email')?.errors">
                                        <small *ngIf="form.get('email')?.errors?.required">
                                            Required
                                        </small>
                                        <small *ngIf="form.get('email')?.errors?.pattern">
                                            Please Provide Valid email ex.abcd&#64;gmail.com
                                        </small>
                                    </small>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="company">Company Name</label>
                                    <input type="text" formControlName="company"
                                        class="form-control mb-4 text-uppercase" id="company">
                                    <!-- <div class="invalid-feedback">
                                        Please Provide Company Name
                                    </div> -->
                                    <small class="error-msg "
                                        *ngIf="form.get('company')?.dirty && form.get('company')?.errors">
                                        <small *ngIf="form.get('company')?.errors?.required">
                                            Required
                                        </small>
                                    </small>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="pan">PAN</label>
                                    <input type="text" maxlength="10" formControlName="pan"
                                        class="form-control mb-4 text-uppercase" id="pan">
                                </div>
                                <!-- <small class="error-msg"
                                    *ngIf="form.get('mobileNo')?.dirty && form.get('mobileNo')?.errors">
                                    <small *ngIf="form.get('mobileNo')?.errors?.required">
                                        required
                                    </small>
                                </small> -->
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="gstin">GSTIN</label>
                                    <input type="text" formControlName="gstin" class="form-control mb-4 text-uppercase"
                                        id="gstin">
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="city">Address</label>
                                    <input type="text" class="form-control mb-4" formControlName="address" id="address">
                                    <!-- <div class="invalid-feedback">
                                        Please Provide Address
                                    </div> -->
                                    <small class="error-msg"
                                        *ngIf="form.get('address')?.dirty && form.get('address')?.errors">
                                        <small *ngIf="form.get('address')?.errors?.required">
                                            Required
                                        </small>
                                    </small>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="city">City</label>
                                    <input type="text" class="form-control mb-4" formControlName="city" id="city">
                                    <!-- <div class="invalid-feedback">
                                        Please Provide City
                                    </div> -->
                                    <small class="error-msg"
                                        *ngIf="form.get('city')?.dirty && form.get('city')?.errors">
                                        <small *ngIf="form.get('city')?.errors?.required">
                                            Required
                                        </small>
                                    </small>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="state">State</label>
                                    <select class="form-control" formControlName="state" id="state"
                                        (change)="getGeofenceData()">
                                        <option value="">Select State</option>
                                        <option value="Assam">Assam</option>
                                        <option value="Bihar">Bihar</option>
                                        <option value="West Bengal">West Bengal</option>
                                        <option value="Maharashtra">Maharashtra</option>
                                    </select>
                                    <div class="invalid-feedback">
                                        Please Provide State
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="pin">PIN Code</label>
                                    <input type="text" maxlength="6" max="6" (keypress)="restrictNumeric($event)"
                                        class="form-control mb-4" formControlName="pin" id="pin">
                                    <small class="error-msg" *ngIf="form.get('pin')?.dirty && form.get('pin')?.errors">
                                        <small *ngIf="form.get('pin')?.errors?.required">
                                            Required
                                        </small>
                                    </small>
                                    <!-- <div class="invalid-feedback">
                                        Please Provide PIN No.
                                    </div> -->
                                </div>
                            </div>

                            <!-- <div class="col-md-6">
                                <div class="form-group">
                                    <label for="category">Category</label>
                                    <angular2-multiselect [data]="multipleCategory" [(ngModel)]="selectedCategory"
                                        formControlName="category" id="category" [settings]="categorySettings">
                                    </angular2-multiselect>
                                </div>
                            </div> -->

                            <!-- <div class="col-md-6">
                                <div class="form-group">
                                    <label for="movementType">Movement Type</label>
                                    <angular2-multiselect [data]="multipleMovement" [(ngModel)]="selectedMovement"
                                        formControlName="movementType" id="movementType" [settings]="movementSettings">
                                    </angular2-multiselect>
                                </div>
                            </div> -->

                            <!-- <div class="col-md-12">
                                <div class="form-group">
                                    <label for="checkPoint">Checkpoint for your movement</label>
                                    <angular2-multiselect [data]="multipleCheckPoint" [(ngModel)]="selectedCheckPoint"
                                        formControlName="checkPoint" id="checkPoint" [settings]="checkPointSettings">
                                    </angular2-multiselect>
                                </div>
                            </div> -->


                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="checkPoint">Select Locations</label> 
                                    <angular2-multiselect [data]="multipleGeofences" [(ngModel)]="selectedCheckPoint"
                                        formControlName="checkPoint" id="checkPoint" [settings]="checkPointSettings">
                                    </angular2-multiselect>
                                </div>
                            </div>

                            
                            <!-- <div class="col-md-12">
                                <div class="form-group">
                                    <label for="checkPoint">Loaction</label>
                                    <angular2-multiselect [data]="geofence_list" formControlName="selectedLocation"
                                        id="selectedLocation" [settings]="selectedLocationSettings">
                                    </angular2-multiselect>
                                </div>
                            </div> -->

                            <div class="form-group col-md-12 mb-0">
                                <label for="password" class="col-form-label">Password</label>
                                <input formControlName="password" type="text" class="form-control" id="password">
                                <!-- <div class="invalid-feedback">
                                    Please provide the new password
                                </div> -->
                                <small class="error-msg"
                                    *ngIf="form.get('password')?.dirty && form.get('password')?.errors">
                                    <small *ngIf="form.get('password')?.errors?.required">
                                        Required
                                    </small>
                                    <small *ngIf="form.get('password')?.errors?.pattern">
                                        Please Provide Valid Password
                                    </small>
                                </small>
                            </div>
                            <div class="form-group col-md-12">
                                <small>
                                    <code>
                                        Password must contain 1 uppercase, 1 lowercase, 1 special case & 1 numeric character & of minimum 8 characters
                                    </code>
                                </small>
                            </div>

                            <div class="form-group col-md-12 mb-0 text-center">
                                <div class="field-wrapper mb-2">
                                    <button type="submit" [disabled]="checkValidity()" class="btn btn-primary"
                                        (click)="submitForm()">Register</button>
                                </div>
                            </div>

                        </div>
                    </form>


                    <p class="terms-conditions">© 2020 All Rights Reserved. <b>Transecur Telematics Pvt. Ltd</b>.</p>

                </div>
            </div>
        </div>
    </div>
    <div class="form-image">
        <div class="l-image">
        </div>
    </div>
</div>